export default "__VITE_ASSET__DWJVeISp__"